import { UtmParams } from "@/types/common/utm";

const STORAGE_KEY = "GailUtmData";

export function captureUtmData(): void {
   try {
      if (globalThis.window === undefined) return;
      if (globalThis.window.localStorage.getItem(STORAGE_KEY)) return;

      const params = new URLSearchParams(globalThis.window.location.search);

      const utmSource = params.get("utm_source") || undefined;
      const utmMedium = params.get("utm_medium") || undefined;
      const utmCampaign = params.get("utm_campaign") || undefined;
      const utmTerm = params.get("utm_term") || undefined;
      const utmContent = params.get("utm_content") || undefined;

      let referrer: string | undefined;
      if (document.referrer) {
         try {
            const referrerHost = new URL(document.referrer).hostname;
            if (referrerHost !== globalThis.window.location.hostname) {
               referrer = document.referrer;
            }
         } catch {
            // Invalid referrer URL — ignore
         }
      }

      const data: UtmParams = {
         ...(utmSource && {utmSource}),
         ...(utmMedium && {utmMedium}),
         ...(utmCampaign && {utmCampaign}),
         ...(utmTerm && {utmTerm}),
         ...(utmContent && {utmContent}),
         ...(referrer && {referrer}),
      };

      if (Object.keys(data).length === 0) return;

      globalThis.window.localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
   } catch {
      // localStorage unavailable — silently fail
   }
}

export function getUtmParams(): UtmParams | undefined {
   try {
      if (globalThis.window === undefined) return undefined;
      const raw = globalThis.window.localStorage.getItem(STORAGE_KEY);
      if (!raw) return undefined;
      return JSON.parse(raw) as UtmParams;
   } catch {
      return undefined;
   }
}
